import _defineProperty from "/app/workspaces/v_1/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { CloudImageEditorBase } from './CloudImageEditorBase.js';
import { classNames } from './lib/classNames.js';
export class EditorButtonControl extends CloudImageEditorBase {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init$", {
      ...this.init$,
      active: false,
      title: '',
      icon: '',
      'on.click': null
    });
  }
  initCallback() {
    super.initCallback();
    this._titleEl = this.ref['title-el'];
    this._iconEl = this.ref['icon-el'];
    this.setAttribute('role', 'button');
    if (this.tabIndex === -1) {
      this.tabIndex = 0;
    }
    this.sub('title', title => {
      let titleEl = this._titleEl;
      if (titleEl) {
        this._titleEl.style.display = title ? 'block' : 'none';
      }
    });
    this.sub('active', active => {
      this.className = classNames({
        active: active,
        not_active: !active
      });
    });
    this.sub('on.click', onClick => {
      this.onclick = onClick;
    });
  }
}
EditorButtonControl.template = /* HTML */"\n  <div class=\"before\"></div>\n  <lr-icon size=\"20\" set=\"@name: icon;\"></lr-icon>\n  <div class=\"title\" ref=\"title-el\">{{title}}</div>\n";